/**
 * Error Classes
 * Domain-specific errors for better error handling
 */

class NoOutlineError extends Error {
  constructor(message: string = 'No outline/bookmarks found in this PDF') {
    super(message);
    this.name = 'NoOutlineError';
  }
}

class InvalidPdfError extends Error {
  constructor(message: string = 'Invalid PDF file') {
    super(message);
    this.name = 'InvalidPdfError';
  }
}

class ProcessingError extends Error {
  constructor(message: string = 'Failed to process PDF') {
    super(message);
    this.name = 'ProcessingError';
  }
}

class InvalidCsvError extends Error {
  constructor(message: string = 'Invalid CSV file or parameters') {
    super(message);
    this.name = 'InvalidCsvError';
  }
}

class InvalidJsonError extends Error {
  constructor(message: string = 'Invalid JSON') {
    super(message);
    this.name = 'InvalidJsonError';
  }
}

class InvalidRubyHashError extends Error {
  constructor(message: string = 'Invalid Ruby Hash format') {
    super(message);
    this.name = 'InvalidRubyHashError';
  }
}

export { 
  NoOutlineError, 
  InvalidPdfError, 
  ProcessingError, 
  InvalidCsvError,
  InvalidJsonError,
  InvalidRubyHashError
};
